<template>
  <div v-if="pageJson">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'TemplateProvider',
  props: {
    api: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      pageType: 'page-versions',
      pageJson: []
    };
  },
  created() {},
  mounted() {},
  methods: {
    unzipLayout(jsonObjStr) {
      let _atob = '';
      try {
        _atob = decodeURIComponent(escape(atob(jsonObjStr)));
      } catch (e) {
        _atob = jsonObjStr;
      }

      return JSON.parse(_atob);
    }
  }
};
</script>
<style scoped>
.configlist tr {
  cursor: pointer;
}
</style>
